<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">餐费充值记录</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>餐费管理</el-breadcrumb-item>
                            <el-breadcrumb-item>餐费充值记录</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
                        @submit.native.prevent>
                        <el-form-item prop="userName" label="用户姓名：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.userName" size="small" placeholder="请输入用户姓名" clearable>
                            </el-input>
                        </el-form-item>
<!--                        <el-form-item prop="payStatus" label="支付状态：" style="margin-bottom: 0;">
                            <el-select size="small" v-model="form_search.payStatus" placeholder="请选择" style="width: 120px;">
                                <el-option v-for="item in payStatusList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>-->
                        <el-form-item label="创建时间：" style="margin-bottom: 0;">
                            <el-date-picker size="small" clearable v-model="create_range" type="daterange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" size="small" @click="searchList()">查询</el-button>
                            <el-button type="success" size="small" @click="handleExport">导出</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
                            tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="orderNo" align="center" label="订单号" min-width="200">
                            </el-table-column>
                            <el-table-column prop="userName" align="center" label="用户姓名" min-width="120">
                            </el-table-column>
                            <el-table-column prop="mobile" align="center" label="手机号码" min-width="120">
                            </el-table-column>
                            <el-table-column prop="amount" align="center" label="充值金额（元）" min-width="130">
                            </el-table-column>
                            <el-table-column prop="payStatus" align="center" label="支付状态" min-width="100">
                                <template slot-scope="scope">
                                    <span :class="'status-' + scope.row.payStatus">
                                        {{ payStatusMap[scope.row.payStatus] }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="transactionId" align="center" label="微信订单号" min-width="220">
                            </el-table-column>
                            <el-table-column prop="createdate" align="center" label="创建时间" min-width="160">
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="table_data.page_info.page" :page-sizes="[10, 30, 50, 80, 100]"
                        :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
                        :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '@/assets/js/config';
    export default {
        name: 'mealRechargeRecordList',
        data() {
            return {
                clientHeight: '',
                body_loading: false,
                create_range: '',
                payStatusMap: {
                    0: '待支付',
                    1: '已支付',
                    2: '已退款',
                    3: '已取消'
                },
                payStatusList: [
                    { id: '', name: '全部' },
                    { id: 0, name: '待支付' },
                    { id: 1, name: '已支付' },
                    { id: 2, name: '已退款' },
                    { id: 3, name: '已取消' }
                ],
                form_search: {
                    userName: '',
                    payStatus: '1',
                    startDate: '',
                    endDate: ''
                },
                table_data: {
                    loading: false,
                    list: [],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 0
                    }
                }
            }
        },
        created() {
            document.title = '餐费充值记录';
            this.getList();
        },
        methods: {
            searchList() {
                this.table_data.page_info.page = 1;
                this.getList();
            },
            getList() {
                var _this = this;
                var params = {
                    userName: _this.form_search.userName,
                    payStatus: _this.form_search.payStatus,
                    startDate: _this.form_search.startDate,
                    endDate: _this.form_search.endDate,
                    pageNo: _this.table_data.page_info.page,
                    pageSize: _this.table_data.page_info.pageSize
                };
                _this.table_data.loading = true;
                _this.$client.get('/api/biz/meal/recharge/order/getList', params, function(res) {
                    _this.table_data.list = res;
                    _this.table_data.loading = false;
                }, function() {
                    _this.table_data.loading = false;
                });
            },
            handleExport() {
                var _this = this;
                var params = {
                    userName: _this.form_search.userName,
                    payStatus: _this.form_search.payStatus,
                    startDate: _this.form_search.startDate,
                    endDate: _this.form_search.endDate
                };
                var queryString = Object.keys(params)
                    .filter(key => params[key] !== '' && params[key] !== null && params[key] !== undefined)
                    .map(key => `${key}=${encodeURIComponent(params[key])}`)
                    .join('&');
                if (queryString) queryString += '&';
                window.open(
                    config.api_url + '/api/biz/meal/recharge/order/export?' +
                    queryString + 'token=' + localStorage.getItem('token') + '&loginFrom=pc',
                    '_blank'
                );
            },
            handleSizeChange(val) {
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight) {
                this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
            }
        },
        mounted() {
            this.clientHeight = `${document.documentElement.clientHeight}`;
            window.onresize = () => {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            clientHeight(val) {
                this.changeFixed(val);
            },
            create_range(newVal) {
                if (newVal == null) {
                    this.form_search.startDate = '';
                    this.form_search.endDate = '';
                } else {
                    this.form_search.startDate = newVal[0];
                    this.form_search.endDate = newVal[1];
                }
            }
        }
    }
</script>

<style scoped>
    .status-0 { color: #9a9a9a; }
    .status-1 { color: #04B365; }
    .status-2 { color: #F27918; }
    .status-3 { color: #F31A5C; }
</style>
